import React, { useMemo } from "react"
import { useLocation } from "react-router"
import { frames, icons, useMediaQuery } from "../../Styles"
import { CoreNavLink } from "../../Components"
import { NavLinkTypes } from "../../Definitions"
import { StyleObject } from "styletron-react"
import { ToolsMenu_Pages } from "../pages"

interface MenuItem {
  id: number;
  label: string;
  page: ToolsMenu_Pages;
  icon: any;
  disabled?: boolean;
}

const primaryItems: MenuItem[] = [
  { id: 0, label: "aico", page: ToolsMenu_Pages.log, icon: icons.system2 },
  { id: 1, label: "companies", page: ToolsMenu_Pages.companies, icon: icons.system2 },
  { id: 2, label: "users", page: ToolsMenu_Pages.users, icon: icons.system2 },
  { id: 3, label: "legacy", page: ToolsMenu_Pages.graphQL, icon: icons.system2}
]
const SubItems: MenuItem[] = [
  { id: 4, label: "log", page: ToolsMenu_Pages.log, icon: icons.system2 },
  { id: 5, label: "software", page: ToolsMenu_Pages.firmware, icon: icons.system2 },
  { id: 6, label: "config", page: ToolsMenu_Pages.config, icon: icons.system2 },
  { id: 7, label: "device data tables", page: ToolsMenu_Pages.deviceDataTables, icon: icons.system2 }
]
interface ToolsMenu_Props {
  subMenu?: boolean
  aicoClick?: () => void
  onMenuClick?: (id: number, page: ToolsMenu_Pages) => void;
  overrides?:{
    gridArea?: string
  }
}

export default function ToolsMenu({ subMenu = false, aicoClick, onMenuClick, overrides }: ToolsMenu_Props) {
  const location = useLocation();
  const groupMenu2columns = useMediaQuery(`(max-width: 454px), (min-width: 1000px)`)
  const groupMenu3columns = useMediaQuery(`(min-width: 455px) and (max-width: 590px)`)

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject, //default style
      overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  }, [overrides])

  const NavLinksToShow: MenuItem[] = subMenu ? SubItems : primaryItems

  return (
    <frames.GlobalMenu $style={_Root}>
      <div style={{width: groupMenu2columns ? "265px" : groupMenu3columns ? "400px" : "535px", display: "flex", flexWrap: "wrap", justifyContent: "start", gap: "5px" }}>
        {NavLinksToShow.map(({ id, label, page, icon, disabled }) => {
          const pushActiveStyles = !subMenu && id === 0 && (
            location.pathname.includes(`/${ToolsMenu_Pages.log}`) ||
            location.pathname.includes(`/${ToolsMenu_Pages.firmware}`) ||
            location.pathname.includes(`/${ToolsMenu_Pages.config}`) ||
            location.pathname.includes(`/${ToolsMenu_Pages.deviceDataTables}`)
          );

          return (
            <CoreNavLink
              tabIndex={id}
              key={id}
              content={label}
              path={page}
              endPath={false}
              icon={icon}
              navLinkType={NavLinkTypes.globalMenuNavLink}
              disabled={disabled}
              additionalOnclik={() => {
                if (aicoClick) aicoClick();
                if (onMenuClick) onMenuClick(id, page);
              }}
              pushActiveStyles={pushActiveStyles}
            />
          )
        })}
      </div>
    </frames.GlobalMenu>
  )
}